import { useEffect, useRef } from 'react'
import { mutation, query } from '../graphql/api'
import { useAnalyseContext } from '../context/analyse-context'
import { useTimer } from './use-timer'
import { localStorage } from '../utils/local-storage'

const saveTemporaryData = async (analyse_id, isFinalizing) => {
  if (isFinalizing.current) return

  const current = await query({
    query: 'getCareerAnalyse',
    variables: { id: analyse_id },
    authMode: 'AWS_IAM'
  })

  if (isFinalizing.current || current?.status === 'COMPLETED') return

  const estimationsStorageKey = `estimations-${analyse_id}`
  const seenStorageKey = `seen-${analyse_id}`
  const timeNeededStorageKey = `time-needed-${analyse_id}`

  const estimations = localStorage.getItem(estimationsStorageKey) || {}
  const seen = localStorage.getItem(seenStorageKey) || []
  const time_needed = localStorage.getItem(timeNeededStorageKey)

  const _temp = { estimations, seen }

  await mutation({
    mutation: 'updateCareerAnalyse',
    input: {
      id: analyse_id,
      input: JSON.stringify({ _temp }),
      time_needed: JSON.stringify(time_needed)
    },
    authMode: 'AWS_IAM'
  })
}

export const useTimerAndSaveTemp = () => {
  const {
    state: currentState,
    careerAnalyse,
    finishAnalyse
  } = useAnalyseContext()

  const lastState = useRef(currentState)
  const timeNeeded = useRef(JSON.parse(careerAnalyse.time_needed || '{}'))
  const isFinalizing = useRef(false)

  const { startTimer, stopTimer, pauseTimer, resumeTimer } = useTimer()

  useEffect(() => {
    if (currentState === 'OUTRO') {
      stopTimer()
      return
    }

    // a state change happened
    // track the time for the last state
    const elapsedTime = stopTimer()
    const timeForState =
      (timeNeeded.current[lastState.current] ?? 0) + elapsedTime

    timeNeeded.current = {
      ...timeNeeded.current,
      [lastState.current]: timeForState
    }

    const storageKey = `time-needed-${careerAnalyse.id}`
    localStorage.setItem(storageKey, timeNeeded.current)

    const doAsync = async () => {
      if (currentState === 'FINISH_ANALYSE') {
        isFinalizing.current = true
        await finishAnalyse()
      } else if (currentState !== 'OUTRO') {
        await saveTemporaryData(careerAnalyse.id, isFinalizing)
      }

      // Timer erst NACH dem Speichern starten
      startTimer()
      lastState.current = currentState
    }

    doAsync()
  }, [currentState, careerAnalyse.id, startTimer, stopTimer, finishAnalyse])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) pauseTimer()
      else resumeTimer()
    }

    window.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      window.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [pauseTimer, resumeTimer])

  return null
}
